<template>
  <div class="language-page">
    <div class="header">
      <span class="back-btn" @click="$router.go(-1)"> &lt; 返回 </span>
      <span class="title">选择语言 / Select Language</span>
    </div>

    <div class="lang-list">
      <div class="lang-item" @click="changeLang('zh')">
        <span>简体中文</span>
        <span v-if="currentLang === 'zh'" class="check-mark">✓</span>
      </div>
      <div class="lang-item" @click="changeLang('en')">
        <span>English</span>
        <span v-if="currentLang === 'en'" class="check-mark">✓</span>
      </div>
      <div class="lang-item" @click="changeLang('pt')">
        <span>Português</span>
        <span v-if="currentLang === 'pt'" class="check-mark">✓</span>
      </div>
      <div class="lang-item" @click="changeLang('th')">
        <span>ภาษาไทย</span>
        <span v-if="currentLang === 'th'" class="check-mark">✓</span>
      </div>
      <div class="lang-item" @click="changeLang('vi')">
        <span>Tiếng Việt</span>
        <span v-if="currentLang === 'vi'" class="check-mark">✓</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'language',
  data() {
    return {
      // 获取当前语言，默认设为 zh
      currentLang: this.$i18n ? this.$i18n.locale : 'zh'
    };
  },
  methods: {
    changeLang(lang) {
      this.currentLang = lang;
      if (this.$i18n) {
        this.$i18n.locale = lang; // 切换语言
      }
      localStorage.setItem('lang', lang); // 存入本地缓存
      
      // 延迟一点点返回上一页，让用户能看到打钩的动画
      setTimeout(() => {
        this.$router.go(-1);
      }, 200);
    }
  }
};
</script>

<style scoped>
.language-page { 
  min-height: 100vh; 
  padding-bottom: 24px;
  background: #fff;
  color: #2d241d; 
}
.header { 
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex; 
  align-items: center; 
  padding: 15px 20px;
  background: linear-gradient(135deg, #603514 0%, #965723 62%, #bd7a38 100%);
  color: #fff;
  box-shadow: 0 6px 16px rgba(96, 53, 20, 0.18);
}
.back-btn { 
  font-size: 16px; 
  margin-right: 20px; 
  cursor: pointer;
  color: #fff;
}
.title { 
  font-size: 16px; 
  font-weight: bold; 
  flex: 1;
  text-align: center;
  padding-right: 30px; 
}
.lang-list { 
  padding: 16px 15px;
}
.lang-item { 
  display: flex; 
  justify-content: space-between; 
  align-items: center;
  margin-bottom: 10px;
  padding: 17px 16px;
  border: 1px solid #eadfd2;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 6px 14px rgba(104, 69, 36, 0.08);
  cursor: pointer; 
  font-size: 15px;
}
.check-mark { 
  color: #9a5a27;
  font-weight: bold; 
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/language.vue